import * as React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import CampaignPayoutsHeaderInfo from 'modules/campaigns/components/payments/payouts/header-info/CampaignPayoutsHeaderInfo';
import CcmCampaignPaymentsPayoutsHeaderDetails from './details/CcmCampaignPaymentsPayoutsHeaderDetails';
import CcmCampaignPaymentsPayoutsHeaderMessageButton from './message-button/CcmCampaignPaymentsPayoutsHeaderMessageButton';

import { __t, applyTranslations } from 'utils/language';
import { logError } from 'utils/log';
import { getPaymentInfoForSubcampaignId, preparePaymentInfoForRendering } from '../../../utils/payouts';

import './ccm-campaign-payments-payouts-header.scss';

import { Result, Subcampaign } from 'types';
import type {
  CcmCampaignPaymentsState
} from '../../../redux/types/CcmCampaignPaymentsRedux.type';
import { ViewPaymentInfo } from '../../../types/PaymentInfo.type';

applyTranslations(require('./ccm-campaign-payments-payouts-header.i18n.json'));

interface OwnProps {
  campaignId: number,
  subcampaign: Subcampaign
}

interface StateProps {
  paymentInfo: Result<ViewPaymentInfo, string>
}

type Props = OwnProps & StateProps;

const EMPTY_PAYMENT_INFO: ViewPaymentInfo = {
  amounts: {
    agreed: 0,
    budget: 0,
    total: 0,
    variable: 0
  },
  label: __t('ccm_campaign_payments_payouts_header.labels.payment_info'),
  value: '—'
};

const CcmCampaignPaymentsPayoutsHeader = ({
  campaignId,
  paymentInfo,
  subcampaign
}: Props) => {
  React.useEffect(() => {
    if (paymentInfo.type === 'error') {
      logError(new Error(paymentInfo.error));
    }
  }, [paymentInfo.type]);

  const payment: ViewPaymentInfo = paymentInfo.type === 'error'
    ? EMPTY_PAYMENT_INFO
    : paymentInfo.value;

  return (
    <div className="ccm-campaign-payments-payouts-header">
      <div>
        <CampaignPayoutsHeaderInfo
          profile={subcampaign.creatorProfile}
          paymentInfo={{
            label: payment.label,
            value: payment.value,
            // amounts are irrelevant here,
            // passing an object sutisfying the expected type
            amounts: {
              agreed: 0,
              budget: 0,
              total: 0,
              variable: 0
            }
          }}
        />
      </div>
      <div className="ccm-campaign-payments-payouts-header__details-container">
        <CcmCampaignPaymentsPayoutsHeaderDetails
          data={{
            affiliatedCompensation: payment.amounts.variable,
            offerBudget: payment.amounts.budget
          }}
        />
      </div>
      <div className="ccm-campaign-payments-payouts-header__button-container">
        <CcmCampaignPaymentsPayoutsHeaderMessageButton
          campaignId={campaignId}
          subcampaignId={subcampaign.id}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (
  { ccmCampaignPayments }: { ccmCampaignPayments: CcmCampaignPaymentsState },
  { subcampaign }: OwnProps
): StateProps => ({
  paymentInfo: preparePaymentInfoForRendering(getPaymentInfoForSubcampaignId(
    ccmCampaignPayments.creatorPayouts,
    subcampaign.id,
    __t('ccm_campaign_payments_payouts_header.labels.payment_info')
  ), subcampaign?.campaign?.timeline || null, moment())
});

export default connect(mapStateToProps)(CcmCampaignPaymentsPayoutsHeader);
